module.exports = __webpack_public_path__ + "img/9788992711401.0868e9b3.jpg";